// UserService.js
// import api from './api'; // or axios import
const API_BASE_URL = 'http://localhost/digex/mariage/api';

class UserService {
  // Get all users
  async getAllUsers() {
    try {
    //   const response = await api.get('/users');
      const response = await fetch(`${API_BASE_URL}/users`);
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  }

    // Get user by ID
    async getUserById(userId) {
        if (!userId) {
            throw new Error("User ID is required");
        }
        try {
            const url = `${API_BASE_URL}/users/?id=${userId}`;
            console.log("Fetching user with ID:", userId);
            console.log("Request URL:", url);

            const response = await fetch(url, {
                method: 'GET',
                // No Content-Type header needed for GET requests without body
            });

            console.log("Response status:", response.status);

            if (!response.ok) {
                const errorMessage = `HTTP error! status: ${response.status}`;
                console.error("Error response status:", response.status);
                throw new Error(errorMessage);
            }

            const data = await response.json();
            console.log("Parsed response data:", data);

            if (!data.success) {
                throw new Error(data.error || 'Unknown error occurred');
            }

            return data.user; // Return just the user object
        } catch (error) {
            console.error(`Error fetching user ${userId}:`, error);
            throw error;
        }
    }

  // Create new user
  async createUser(userData) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/`, userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  }

  // Update user
  async updateUser(userId, userData) {
    try {
        const response = await fetch(`${API_BASE_URL}/users/?id=${userId}`, {
            method: 'PUT', // Use PUT for updates
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData), // Send the user data in the body
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`Error updating user ${userId}:`, error);
        throw error;
    }
}

  // Delete user
  async deleteUser(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/users?id=${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting user ${userId}:`, error);
      throw error;
    }
  }
}

// Export as singleton instance
export default new UserService();